<script>

    import { toast } from 'bulma-toast'

    const { HOST_APP } = _CONST_
    
    export let shipmetId = ''

    let referenceInput = null

    function onCopy() {
        referenceInput.select()
        referenceInput.setSelectionRange(0, 99999)
        document.execCommand("copy")
        toast({message: 'Link copiado', type: 'is-success'})
    }

</script>

<div class="items space">
    <div class="field" style="width: 100%; margin: 0;">
        <div class="control has-icons-left">
            <span class="icon"><i class="fas fa-link"></i></span>
            <input bind:this={ referenceInput } value={`${HOST_APP}/#/tracking/${ shipmetId }`} class="input" readonly>
        </div>
    </div>
    <button on:click={onCopy} class="button space left" data-tooltip="Copiar link">
        <span class="icon"><i class="fas fa-copy"></i></span>
    </button>
</div>